
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[[...uri]]",
      function () {
        return require("private-next-pages/[lang]/[[...uri]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[[...uri]]"])
      });
    }
  